import { useState } from "react";
import { Menu, X } from "lucide-react";

const Header = ({ isScrolled }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navLinks = [
    { href: "#inicio", label: "Inicio" },
    { href: "#carta", label: "Carta" },
    { href: "#bodega", label: "Bodega" },
    { href: "#catas", label: "Catas" },
    { href: "#reservas", label: "Reservas" },
    { href: "#contacto", label: "Contacto" },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <header
        className={`fixed w-full z-40 transition-all duration-300 ${
          isScrolled
            ? "bg-white/95 backdrop-blur-md border-b border-[#DCD7CC] py-3"
            : "bg-transparent py-5"
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
          {/* Logo */}
          <a
            href="#inicio"
            onClick={(e) => scrollToSection(e, "#inicio")}
            data-testid="header-logo"
            className="flex flex-col"
          >
            <span
              className={`font-heading text-xl md:text-2xl tracking-wide transition-colors ${
                isScrolled ? "text-[#1A1A1A]" : "text-white"
              }`}
            >
              Abacería
            </span>
            <span
              className={`font-accent text-sm tracking-widest uppercase transition-colors ${
                isScrolled ? "text-[#800020]" : "text-[#C5A059]"
              }`}
            >
              Como en Casa
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                data-testid={`nav-${link.label.toLowerCase()}`}
                className={`nav-link font-body text-sm uppercase tracking-widest transition-colors ${
                  isScrolled
                    ? "text-[#1A1A1A] hover:text-[#800020]"
                    : "text-white hover:text-[#C5A059]"
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Desktop CTA */}
          <a
            href="#reservas"
            onClick={(e) => scrollToSection(e, "#reservas")}
            data-testid="header-reserve-btn"
            className={`hidden md:block px-6 py-3 text-xs uppercase tracking-widest transition-all ${
              isScrolled
                ? "bg-[#800020] text-white hover:bg-[#600018]"
                : "bg-white/10 backdrop-blur-sm border border-white/30 text-white hover:bg-white/20"
            }`}
          >
            Reservar Mesa
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            data-testid="mobile-menu-btn"
            className={`md:hidden p-2 transition-colors ${
              isScrolled ? "text-[#1A1A1A]" : "text-white"
            }`}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <div
        className={`menu-overlay ${isMobileMenuOpen ? "open" : ""}`}
        onClick={() => setIsMobileMenuOpen(false)}
      />

      {/* Mobile Menu */}
      <div
        className={`mobile-menu ${isMobileMenuOpen ? "open" : ""}`}
        data-testid="mobile-menu"
      >
        <div className="p-6">
          <div className="flex justify-between items-center mb-8">
            <span className="font-heading text-xl">Abacería</span>
            <button
              onClick={() => setIsMobileMenuOpen(false)}
              data-testid="close-mobile-menu"
            >
              <X size={24} />
            </button>
          </div>
          <nav className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                data-testid={`mobile-nav-${link.label.toLowerCase()}`}
                className="font-body text-lg py-2 border-b border-[#DCD7CC] hover:text-[#800020] transition-colors"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <a
            href="#reservas"
            onClick={(e) => scrollToSection(e, "#reservas")}
            data-testid="mobile-reserve-btn"
            className="block w-full mt-8 py-4 bg-[#800020] text-white text-center text-sm uppercase tracking-widest hover:bg-[#600018] transition-colors"
          >
            Reservar Mesa
          </a>
        </div>
      </div>
    </>
  );
};

export default Header;
